export default "__VITE_ASSET__dbcc7181__"